import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class PackageCustomFieldsTableComponent implements IController {
  fields: any[];
  onEdit: Function;
  onDelete: Function;


  $onInit() {

  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('packageCustomFieldsTable', {
    bindings: {
      fields: '<?',
      onEdit: '&',
      onDelete: '&',
    },
    template: require('./package-custom-fields-table.html').default,
    controller: PackageCustomFieldsTableComponent
  });
